import {
  authLoginLogic,
  authLoginSuccessLogic
} from './login';

import {
  authLogoutLogic,
  authLogoutSuccessLogic
} from './logout';

import {authErrorLogic} from './error';
import {authRefreshSessionLogic} from './refresh';
import {authResetStorageLogic} from './reset';

export default [
  authRefreshSessionLogic,
  authLoginLogic,
  authLogoutLogic,
  authLoginSuccessLogic,
  authLogoutSuccessLogic,
  authErrorLogic,
  authResetStorageLogic
];



// WEBPACK FOOTER //
// ./src/util/redux/auth/logic/index.js